import axios from "axios";
import { ScreeningQuestionsItem } from "../Components/Prescreen/Questions";
import { CreateJobSchemaType } from "../Components/CreateJobForm/CreateJobScheme";
import { BaseResponse } from "../models/base";

export const deleteJob = async (applicationId: string): Promise<void> => {
  try {
    const response = await axios.post(
      `${
        import.meta.env.VITE_BASE_URL
      }/clients/job/applications/deactivate/${applicationId}`,

      {
        // companyId: localStorage.getItem("companyId"),
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("userId"),
        },
      }
    );
    if (response.data.statusCode === "OK") {
      localStorage.setItem("companyName", response.data.data.companyName);
    } else {
    }
  } catch (error) {
    console.error("Error during company name change:", error);
  } finally {
  }
};

export const createJobApi = async (
  passedData: CreateJobSchemaType,
  applicantsStatusConfig?: any[]
): Promise<BaseResponse<boolean> | undefined> => {
  const jobTypeToTermName = (jobType?: string): string => {
    const normalized = (jobType || "")
      .toLowerCase()
      .replace(/[\s-]/g, "");

    // Keep compatibility with both:
    // - "Full Time" / "Part Time"
    // - "Full-Time" / "Part-Time" (from master/work-types)
    if (normalized.includes("fulltime")) return "Permanent";
    return "Contract";
  };

  const formData: any = {
    jobName: passedData.jobName,
    workType: passedData.workType,
    workLocation: passedData.countryName,
    jobDesc: passedData.jobDesc,
    vacancy: passedData.vacancy || 1,
    minExp: passedData.minExp,
    skills: passedData.skills,
    // Industry is optional — only include it when actually selected, so we don't
    // send empty strings the backend would try (and fail) to cast to an ObjectId.
    ...(passedData.industryId && {
      industryId: passedData.industryId,
      industryName: passedData.industryName,
    }),
    qualTypeName: passedData.qualTypeName,
    jobReq: passedData.jobReq,
    jobLevel: passedData.jobLevel,
    jobLevelId: passedData.jobLevelId,
    workTypeId: passedData.workTypeId,
    workplaceTypeId: (passedData as any).workplaceTypeId,
    minSalary: passedData.minSalary,
    maxSalary: passedData.maxSalary,
    isPrivate: false,
    countryName: passedData.countryName,
    currencyId: passedData.currencyId,
    currencyName: passedData.currencyName,
    qualTypeId: passedData.qualTypeId,
    maxExp: passedData.maxExp,
    termName: jobTypeToTermName(passedData.jobType),
    companyId: localStorage.getItem("companyId"),
    workState: passedData.workState,
    workStateId: passedData.workStateId,
    city: passedData.city,
    countryId: passedData.countryId,
    stateId: passedData.stateId,
    ...(passedData.cityId && { cityId: passedData.cityId }),
  };

  // Add funnel config if provided (for clone job)
  if (applicantsStatusConfig) {
    formData.applicantsStatusConfig = applicantsStatusConfig;
  }

  try {
    const response = await axios.post(
      `${import.meta.env.VITE_BASE_URL}/clients/job/create`,
      formData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("userId"),
        },
      }
    );

    return response.data;
  } catch (error:any) {

    console.error("Error during company name change:", error);
    return error.response.data;
 
  }
};

export const updateStatusApi = async (
  newStatus: string,
  applicationId: string
): Promise<BaseResponse<boolean> | undefined> => {
  try {
    const response = await axios.post(
      `${
        import.meta.env.VITE_BASE_URL
      }/candidate/jobs/applicant/status/${applicationId}`,

      {
        applicationStatus: newStatus,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("userId"),
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error during company name change:", error);
  }
};

export const editJob = async (
  passedData: CreateJobSchemaType,
  jobId: string
): Promise<BaseResponse<boolean> | undefined> => {
  const jobTypeToTermName = (jobType?: string): string => {
    const normalized = (jobType || "")
      .toLowerCase()
      .replace(/[\s-]/g, "");

    if (normalized.includes("fulltime")) return "Permanent";
    return "Contract";
  };

  const formData = {
    jobName: passedData.jobName,
    workType: passedData.workType,
    workLocation: passedData.countryName,
    jobDesc: passedData.jobDesc,
    vacancy: passedData.vacancy || 1,
    minExp: passedData.minExp,
    skills: passedData.skills,
    industryName: passedData.industryName,
    qualTypeName: passedData.qualTypeName,
    jobReq: passedData.jobReq,
    jobLevel: passedData.jobLevel,
    jobLevelId: passedData.jobLevelId,
    workTypeId: passedData.workTypeId,
    workplaceTypeId: (passedData as any).workplaceTypeId,
    minSalary: passedData.minSalary,
    maxSalary: passedData.maxSalary,
    isPrivate: false,
    countryName: passedData.countryName,
    currencyId: passedData.currencyId,
    currencyName: passedData.currencyName,
    qualTypeId: passedData.qualTypeId,
    maxExp: passedData.maxExp,
    termName: jobTypeToTermName(passedData.jobType),
    companyId: localStorage.getItem("companyId"),
    workState: passedData.workState,
    workStateId: passedData.workStateId,
    city: passedData.city,
    countryId: passedData.countryId,
    ...(passedData.stateId && { stateId: passedData.stateId }),
    ...(passedData.cityId && { cityId: passedData.cityId }),
  };

  try {
    const response = await axios.post(
      `${import.meta.env.VITE_BASE_URL}/clients/job/update/${jobId}`,

      formData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("userId"),
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error during company name change:", error);
  }
};

export const deactivateJob = async (
  jobId: string
): Promise<BaseResponse<boolean> | undefined> => {
  try {
    const response = await axios.post(
      `${import.meta.env.VITE_BASE_URL}/clients/job/deactivate/${jobId}`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("userId"),
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error during company name change:", error);
  }
};

// Note: Clone job functionality is now handled through JobForm with type="clone"
// This creates a new job with pre-filled data and funnel configuration

export const getJobDetails = async (jobId: string) => {
  try {
    const data = await axios.get(
      `${import.meta.env.VITE_BASE_URL}/clients/job/get/${jobId}`,

      {
        headers: {
          Authorization: localStorage.getItem("userId"),
        },
      }
    );
    if (data.data.statusCode === "OK") {
      // localStorage.setItem("companyName", response.data.data.companyName);
      return data.data;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error during company name change:", error);
    return false;
  } finally {
  }
};

export const getPreScreenQuestions = async (jobId: string) => {
  try {
    const data = await axios.get(
      `${import.meta.env.VITE_BASE_URL}/clients/job/questions/get/${jobId}`,

      {
        headers: {
          Authorization: localStorage.getItem("userId"),
        },
      }
    );
    if (data.data.statusCode === "OK") {
      // localStorage.setItem("companyName", response.data.data.companyName);
      return data.data;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error during getting pre screen data:", error);
    return false;
  } finally {
  }
};

export const editPreScreenQuestion = async (
  jobId: string,
  questionId: string,
  payload: {}
) => {
  try {
    const data = await axios.post(
      `${
        import.meta.env.VITE_BASE_URL
      }/clients/job/questions/edit/${jobId}/${questionId}`,
      payload,
      {
        headers: {
          Authorization: localStorage.getItem("userId"),
        },
      }
    );
    if (data.data.statusCode === "OK") {
      // localStorage.setItem("companyName", response.data.data.companyName);
      return data.data;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error during getting pre screen data:", error);
    return false;
  } finally {
  }
};

export const deletePreScreenQuestion = async (
  jobId: string,
  questionId: string
) => {
  try {
    const data = await axios.post(
      `${
        import.meta.env.VITE_BASE_URL
      }/clients/job/questions/delete/${jobId}/${questionId}`,
      {},
      {
        headers: {
          Authorization: localStorage.getItem("userId"),
        },
      }
    );
    if (data.data.statusCode === "OK") {
      // localStorage.setItem("companyName", response.data.data.companyName);
      return data.data;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error during getting pre screen data:", error);
    return false;
  } finally {
  }
};

export const setPreScreenQuestion = async (
  jobId: string,
  payload: ScreeningQuestionsItem[]
) => {
  try {
    const data = await axios.post(
      `${import.meta.env.VITE_BASE_URL}/clients/job/questions/set/${jobId}`,

      {
        title: "Pre Screen Questions",
        questions: payload,
      },
      {
        headers: {
          Authorization: localStorage.getItem("userId"),
        },
      }
    );
    if (data.data.statusCode === "OK") {
      // localStorage.setItem("companyName", response.data.data.companyName);
      return data.data;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error during getting pre screen data:", error);
    return false;
  } finally {
  }
};
